module.exports = __webpack_public_path__ + "media/icons/Group-9f8b662b.svg";